import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, testId, children }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[90] flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <button
            aria-label="Close dialog"
            data-testid={`${testId}-backdrop`}
            className="absolute inset-0 cursor-default bg-emerald-ink/80 backdrop-blur-sm"
            onClick={onClose}
          />
          <motion.div
            role="dialog"
            aria-modal="true"
            aria-label={title}
            data-testid={testId}
            initial={{ y: 28, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 28, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="relative max-h-[82vh] w-full max-w-lg overflow-y-auto rounded-sm border border-gold/30 bg-emerald-deep p-8 text-cream shadow-lift"
          >
            <button
              onClick={onClose}
              aria-label="Close"
              data-testid={`${testId}-close`}
              className="absolute right-4 top-4 text-cream/55 transition-colors hover:text-gold"
            >
              <X className="h-5 w-5" />
            </button>
            <h3 className="mb-5 pr-8 font-serif text-2xl font-semibold text-gold">
              {title}
            </h3>
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
